@if (data$ | async; as data) {
<ng-container *ngFor="let module of data.modules">
  <ng-container *appModuleContainer="module"></ng-container>
</ng-container>
}

<app-ready-for-contact-form></app-ready-for-contact-form>